import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/modules/shared.module';
import { UtilsModule } from '@app/modules/utils.module';
import { MaterialImports } from '@environments/environment';
import { LiveEventDetailComponent } from '@components/liveeventdetail.component';
import { FormsModule } from '@angular/forms';
import { LiveSingleEventList } from '@components/live-single-eventlist';

@NgModule({
  declarations: [],
  exports: [],
  imports: [CommonModule, SharedModule, UtilsModule, RouterModule, MaterialImports, FormsModule],
})
export class LiveEventDetailsModule {}
